import { useIntl } from 'react-intl'
import styled from 'styled-components'
import InlineIcon from 'components/utils/InlineIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'
import { rem } from 'polished'

const BookingConditionsList = styled.span`
  display: block;
  text-align: start;
  white-space: pre-line;
`

const BookingConditionsIcon = styled(InlineIcon)`
  --text-icon-size: ${rem(16)};
`

interface Props {
  conditions: Array<App.PackageInclusion>
}

function CruiseBookingConditionsInfo({ conditions }: Props) {
  const intl = useIntl()
  const description = conditions.map((condition) => `• ${condition.description}`).join('\n')
  const label = intl.formatMessage({
    id: 'vuLhdT_gMUlqGZo2OqT3',
    defaultMessage: 'Booking conditions',
    description: 'Accessible label for the tooltip listing cruise inclusion booking conditions',
  })

  return <Tooltip description={<BookingConditionsList>{description}</BookingConditionsList>} placement="bottom-start">
    <BookingConditionsIcon Icon={LineInfoCircleIcon} aria-label={label} colour="normal-contrast" />
  </Tooltip>
}

export default CruiseBookingConditionsInfo
